var startVS = `
void main(void) {
		gl_Position = getPosition();
`;

export { startVS as default };
